<!-- <app-header></app-header> -->
<div class="container main-layout">
    <!-- <app-sidebar-chatbot></app-sidebar-chatbot> -->
    <div class="assign-container fluid-container">
        <div class="top-right-div">
            <div class="first-top">
                <div class="left-titl-buton ">
                    <div class="back-btn" (click)="backbutton()">
                        <img  src="../../../assets/images/back_button_popup.svg" alt="Back-Button">
                    </div>
                    <div class="title">
                        {{traineeDetails.first_name}}'s Sessions
                    </div>
                </div>
            </div>
            <div class="second-top">
                <div class="card" [ngClass]="EditBalance ? '' : 'card-adjust'" >
                    <div class="card-one">
                        <img class="profile-img" src="../../../assets/images/JJ_Icon_Person_RGB (3).svg">
                    </div>
                    <div class="card-two">
                        <span class="ct-1">{{traineeDetails.first_name}}</span>
                        <!-- <span class="ct-2">Sales Consultant</span> -->
                        <!-- <span class="ct-3">Joined: --Check--</span> -->
                        <!-- <span class="ct-4">{{traineeDetails.email}}</span> -->
                    </div>
                    <div class="card-three">
                        <div class="ct-1">Chat sessions: {{traineeDetails.session_count || 0}}</div>
                        <!-- <div class="cth-2"><span>Assigned: --Check-- </span> <span>Completed: --Check-- </span></div> -->
                        <!-- <div class="ct-2" class="ct-1">Roleplay assigned: {{traineeDetails.roleplay_total_count || 0}}
                        </div>
                        <div class="ct-2" class="ct-1">Roleplay completed: {{traineeDetails.roleplay_completed || 0}}
                        </div> -->
                        <!-- <div class="cth-2"><span>Assigned: --Check--</span> <span>Completed: {{traineeDetails.roleplay_completed}}</span></div> -->
                    </div>
                    <!-- <div class="card-four" *ngIf="!EditBalance">
                        <div class="ct-1">Video: {{PendingTime}} hrs remaining</div>
                        <div class="balancehrs">
                            <p>Video {{balanceTime}} of {{allotedTime}} hrs consumed</p>
                        </div>
                        <div class="EditBtnD">
                            <button class="EditAvatar" (click)="EditAvatarTime()">Edit avatar usage</button>
                        </div>

                    </div> -->
                    <!-- <div class="card-four" *ngIf="EditBalance">
                        <div class="CommonD">
                            <div class="editButtonD">
                                <p>Edit Avatar Quota</p>
                            </div>
                            <form [formGroup]="avatarForm">
                            <div class="avatarEnableD">
                                <label class="labels" for="avatar">Avatar Enabled</label>
                                <mat-slide-toggle formControlName="avatar"></mat-slide-toggle>
                            </div>
                        </form>
                        </div>
                        <div class="time-container">
                            <span class="ct-1"> Video:</span>
                            <div class="input-container">
                                <input type="text" class="time-input" maxlength="1" [(ngModel)]="in1"
                                    (input)="moveToNext($event, 1)" autofocus />
                                <input type="text" class="time-input" maxlength="1" [(ngModel)]="in2"
                                    (input)="moveToNext($event, 2)" /><span class="Hrs">Hrs</span>
                                <input type="text" class="time-input" maxlength="1" [(ngModel)]="in3"
                                    (input)="moveToNext($event, 3)" />
                                <input type="text" class="time-input" maxlength="1" [(ngModel)]="in4"
                                    (input)="moveToNext($event, 4)" /><span class="Hrs">Min</span>
                            </div>
                        </div>
                        <div class="balancehrs">
                            <p>Video: {{PendingTime}} hrs balance</p>
                        </div>
                        <div class="SavebtnD">
                            <button class="savebtn" (click)="submitI()">Save</button>
                        </div>
                    </div> -->

                </div>
            </div>
            <div class="top-row">
                <div class="left-titl-buton ">
                    <div class="title">
                        All Sessions
                    </div>
                </div>
                <div class="right-filter">
                    <div class="input-pos">
                    <input matInput #searchInput placeholder="Search with ..." class="filter-search"
                        (input)="applyFilter(searchInput.value)">
                    <i class="fa fa-search search-icon"></i>
                    </div>
                    <div *ngIf="showNoSearchResultsMessage">
                        No search results found.
                    </div>
                </div>
                
            </div>
            <div class="bottom-table">
                <div>
                    <div>
                        <table class="assignee-table mat-elevation-z9" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
                            <ng-container matColumnDef="chat_type">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" class="tab-th">
                                    Session Type
                                </th>
                                <td mat-cell *matCellDef="let element" class="tab-td"> 
                                    {{(element.chat_type == 'Chat') ? 'Chat' : 'Summarizer'}} 
                                </td>
                            </ng-container>
                    
                            <ng-container matColumnDef="chat_start_time">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" class="tab-th">
                                    Attempt Date
                                </th>
                                <td mat-cell *matCellDef="let element" class="tab-td"> 
                                    {{element.chat_start_time | date: 'MM-dd-yyyy hh:mm'}} 
                                </td>
                            </ng-container>
                    
                            <ng-container matColumnDef="total_minutes">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" class="tab-th">
                                    Session Duration(hh:mm:ss)
                                </th>
                                <td mat-cell *matCellDef="let element" class="tab-td">
                                    {{ formatTime(element.total_minutes, element.total_seconds) }}
                                </td>
                            </ng-container>
                    
                            <ng-container matColumnDef="chat_name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" class="tab-th">
                                    Topic
                                </th>
                                <td mat-cell *matCellDef="let element" class="tab-td">
                                    <ng-container> 
                                        <span title="{{element.chat_name}}">{{element.chat_name | truncate:15}}</span>
                                    </ng-container>
                                </td>
                            </ng-container>
                    
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by status" class="tab-th">
                                    Status
                                </th>
                                <td mat-cell *matCellDef="let element" class="tab-td">
                                    <ng-container *ngIf="element.chat_type === 'role-play'">{{element.roleplay_status}}</ng-container>
                                    <ng-container *ngIf="element.chat_type === 'faq'">{{element.faq_status}}</ng-container>
                                </td>
                            </ng-container>
                    
                            <ng-container matColumnDef="trainer_feedback">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number" class="tab-th">
                                    Feedback
                                </th>
                                <td mat-cell *matCellDef="let element" class="tab-td">
                                    <ng-container *ngIf="element.roleplay_status === 'Completed'; else loggedOutTemplate">
                                        <button class="view-feed" (click)="cardClickHandler(element.chat_session_id)">
                                            <span> View and Feedback </span>
                                            <span>&#11167;</span>
                                        </button>
                                    </ng-container>
                                    <ng-template #loggedOutTemplate>
                                        <button class="view-feed clear">
                                            <span> View and Feedback </span>
                                            <span>&#11167;</span>
                                        </button>
                                    </ng-template>
                                </td>
                            </ng-container>
                    
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        
                        <!-- Pagination controls -->
                        <mat-paginator #paginator [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons></mat-paginator>
                    </div>
                    
                </div>
            </div>
        </div>

    </div>
</div>